// extracted by mini-css-extract-plugin
export default {"actions":"JpQ0a8sqK9","forgotPassword":"Oft94eBIuz"};